import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./detalle_dra.css";
import firma from "../../assets/doctora_3.png";
import certificaciones from "../../assets/1.png";
import antesDespues from "../../assets/1.png";
import fondo from "../../assets/opacidad_3.png"; // Importa la imagen de fondo

const DetalleDra = () => {
  // Añade este useEffect para hacer scroll al principio cuando el componente se monte
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div
      style={{
        backgroundImage: `url(${fondo})`, // Aplica la imagen de fondo aquí
        backgroundSize: "50% auto", // Ajusta el tamaño de la imagen (50% del ancho, altura automática)
        backgroundPosition: "center 60%", // Posiciona la imagen en el centro y un 60% desde la parte superior
        backgroundAttachment: "fixed", // Fija la imagen de fondo
        backgroundRepeat: "no-repeat",
        minHeight: "100vh", // Asegura que el fondo cubra toda la pantalla
      }}
    >
      <div className="detalle-container">
        {/* Encabezado */}
        <div className="header-detalle">
          <Link to="/" className="volver-btn">
            ← Volver
          </Link>
          <h1>Dra. Gladys Eugenia Quintero Capera</h1>
          <p className="especialidad">
            Médica Estética | Especialista en Medicina Regenerativa
          </p>
        </div>

        {/* Sección Principal */}
        <div className="perfil-section">
          {/* Columna Izquierda */}
          <div className="columna-izquierda">
            {/* Formación Académica */}
            <div className="tarjeta-perfil">
              <h2>Formación Académica</h2>
              <ul className="formacion-lista">
                <li>
                  <span className="icono">🎓</span>
                  <div>
                    <h3>Médica General</h3>
                    <p>Universidad de Manizales · 2009</p>
                  </div>
                </li>
                <li>
                  <span className="icono">📚</span>
                  <div>
                    <h3>Especialización en Medicina Estética</h3>
                    <p>Universidad del Quindío</p>
                  </div>
                </li>
                <li>
                  <span className="icono">🩺</span>
                  <div>
                    <h3>Diplomado en Terapias Regenerativas</h3>
                    <p>Sociedad Colombiana de Medicina Estética</p>
                  </div>
                </li>
              </ul>
            </div>

            {/* Tecnologías Exclusivas */}
            <div className="tarjeta-perfil">
              <h2>Tecnologías Exclusivas</h2>
              <div className="tecnologias-grid">
                <div className="tecnologia-item">
                  <div className="icono-tecnologia">💎</div>
                  <h3>GLQ® Facial System</h3>
                  <p>Técnica propietaria de armonización 3D</p>
                </div>
                <div className="tecnologia-item">
                  <div className="icono-tecnologia">🔬</div>
                  <h3>Regeneración Capilar RC+</h3>
                  <p>Protocolo combinado PRP + MicroNutrición</p>
                </div>
              </div>
            </div>
          </div>

          {/* Columna Derecha */}
          <div className="columna-derecha">
            {/* Contenedor Sticky (Filosofía + Resultados) */}
            <div className="contenedor-sticky">
              {/* Filosofía de Trabajo */}
              <div className="filosofia-section">
                <h2>Filosofía de Trabajo</h2>
                <blockquote>
                  "Mi enfoque integra tres pilares fundamentales:
                  <span className="destacado">
                    {" "}
                    ciencia, arte y atención personalizada
                  </span>
                  , buscando siempre resultados naturales que respeten tu
                  anatomía única."
                </blockquote>
                <img
                  src={firma}
                  alt="Firma Dra. Quintero"
                  className="firma-img"
                />
              </div>
              {/* Llamado a la Acción */}
              <div className="cta-section">
                <h3>¿Lista para transformar tu piel?</h3>
                <Link to="/contactanos" className="agendar-btn">
                  📅 Agendar Valoración Personalizada
                </Link>
              </div>

              {/* Resultados Comprobados */}
              {/* <div className="resultados-section">
                                <h2>Resultados Comprobados</h2>
                                <img src={antesDespues} alt="Antes y Después" className="antes-despues-img" />
                                <div className="leyenda-resultados">
                                    <span>▲ 98% de satisfacción en tratamientos faciales</span>
                                    <span>► 1500+ casos de éxito</span>
                                </div>
                            </div> */}
            </div>
          </div>
        </div>

        {/* Certificaciones */}
        {/* <div className="certificaciones-section">
                    <h2>Certificaciones Internacionales</h2>
                    <img src={certificaciones} alt="Certificaciones" className="certificaciones-img" />
                </div> */}
      </div>
    </div>
  );
};

export default DetalleDra;